import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import { calendarOutline } from 'ionicons/icons';
import { useNavigate } from 'react-router-dom';
import { AppSectionHeader } from '../components/ui/AppSectionHeader';

export const AdminPage = () => {
  const navigate = useNavigate();

  return (
    <IonPage>
      <AppSectionHeader variant="admin">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/main/perfil" />
          </IonButtons>
          <IonTitle className="ml-4">Administración</IonTitle>
        </IonToolbar>
      </AppSectionHeader>

      <IonContent>
        <IonList inset>
          <IonItem button detail onClick={() => navigate('/app/admin/jornadas')}>
            <IonIcon icon={calendarOutline} slot="start" aria-hidden="true" />
            <IonLabel>Gestión de jornadas</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};
